module.exports = __webpack_public_path__ + "img/pluto52.2d8e25aa.jpg";